import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
import { MENU_ELEMENT_TYPE } from '@/lib/vue-router-menu';
import Icon from '@/components/Icon/Icon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuTree',
    props: {
        tree: {},
        isCollapsed: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_ElIcon = _resolveComponent("ElIcon");
            const _component_ElMenuItem = _resolveComponent("ElMenuItem");
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_MenuTree = _resolveComponent("MenuTree", true);
            const _component_ElSubMenu = _resolveComponent("ElSubMenu");
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tree, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.key
                }, [
                    (item.type === _unref(MENU_ELEMENT_TYPE).ITEM)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 0,
                            to: item.to
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_ElMenuItem, {
                                    index: item.key
                                }, {
                                    title: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                    ]),
                                    default: _withCtx(() => [
                                        (typeof item.icon === 'string')
                                            ? (_openBlock(), _createBlock(_component_ElIcon, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon || 'star')))
                                                ]),
                                                _: 2
                                            }, 1024))
                                            : (typeof item.icon === 'function')
                                                ? (_openBlock(), _createBlock(Icon, {
                                                    key: 1,
                                                    name: item.icon()
                                                }, null, 8, ["name"]))
                                                : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["index"])
                            ]),
                            _: 2
                        }, 1032, ["to"]))
                        : (item.type === _unref(MENU_ELEMENT_TYPE).SUBMENU)
                            ? (_openBlock(), _createBlock(_component_ElSubMenu, {
                                key: 1,
                                index: item.key,
                                "popper-class": "popper-custom"
                            }, {
                                title: _withCtx(() => [
                                    (typeof item.icon === 'string')
                                        ? (_openBlock(), _createBlock(_component_ElIcon, { key: 0 }, {
                                            default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon || 'files')))
                                            ]),
                                            _: 2
                                        }, 1024))
                                        : (typeof item.icon === 'function')
                                            ? (_openBlock(), _createBlock(Icon, {
                                                key: 1,
                                                name: item.icon()
                                            }, null, 8, ["name"]))
                                            : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_component_MenuTree, {
                                        "is-collapsed": props.isCollapsed,
                                        tree: item.children
                                    }, null, 8, ["is-collapsed", "tree"])
                                ]),
                                _: 2
                            }, 1032, ["index"]))
                            : _createCommentVNode("", true)
                ], 64));
            }), 128));
        };
    }
});
